export default __webpack_public_path__ + "bd21ae5e63a50eaa300569038339acf8.png";